package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.GmInventoryItem
import fr.manyverse.app.domain.model.GmInventoryItemToCreate
import fr.manyverse.app.domain.repository.GmInventoryRepository
import fr.manyverse.app.domain.validation.InventoryItemValidator

class CreateGmInventoryItemUseCase(
    private val gmInventoryRepository: GmInventoryRepository
) {
    suspend operator fun invoke(item: GmInventoryItemToCreate): Result<GmInventoryItem> {
        InventoryItemValidator.validateForCreation(item.name, item.quantity).onFailure {
            return Result.failure(it)
        }
        return gmInventoryRepository.createItem(item)
    }
}
